<template src="./Edit.html">
</template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.$store
            .dispatch("employeeLeaves/getForEdit", this.itemId)
            .then((res) => {
                this.leave = res;

            })
            .catch(() => { });
    },
    computed: {


    },
    data() {
        return {
            leave: {
                description: null,
                employeeId: null,
                startDate: null,
                endDate: null,
                officialHoliday: null,
                hasOffical: false,
            },
        };
    },
    methods: {

        checkDate() {
            if (this.leave.startDate > this.leave.endDate) {
                showAlert("يجب ان يكون تاريخ بداية الاجازة اقل من تاريخ نهايتها");
                this.leave.endDate = null;
                return;
            }
        },
        getDuration() {
            if (this.leave.startDate != null && this.leave.endDate != null) {
                if (this.leave.startDate > this.leave.endDate) {
                    this.leave.duration = null;
                    this.leave.endDate = null;
                    showAlert(`يجب ان يكون تاريخ بداية الاجازة قبل نهايتها`);
                } else {
                    const s = new Date(this.leave.startDate);
                    const d = new Date(this.leave.endDate);

                    //const diffTime = Math.abs(d - fromDate);

                    this.leave.duration = this.calcBusinessDays(s, d);
                }
            }
        },

        calcBusinessDays(dDate1, dDate2) {
            // input given as Date objects
            var iWeeks,
                iDateDiff,
                iAdjust = 0;
            if (dDate2 < dDate1) return -1; // error code if dates transposed
            var iWeekday1 = dDate1.getDay(); // day of week
            var iWeekday2 = dDate2.getDay();
            iWeekday1 = iWeekday1 == 6 ? 7 : iWeekday1; // change Sunday from 0 to 7
            iWeekday2 = iWeekday2 == 6 ? 7 : iWeekday2;
            if (iWeekday1 == 5 && iWeekday2 == 5) iAdjust = 1; // adjustment if both days on weekend
            iWeekday1 = iWeekday1 == 5 ? 5 : iWeekday1; // only count weekdays
            iWeekday2 = iWeekday2 == 5 ? 5 : iWeekday2;

            // calculate differnece in weeks (1000mS * 60sec * 60min * 24hrs * 7 days = 604800000)
            iWeeks = Math.floor((dDate2.getTime() - dDate1.getTime()) / 604800000);

            if (iWeekday1 <= iWeekday2) {
                iDateDiff = iWeeks * 5 + (iWeekday2 - iWeekday1);
            } else {
                iDateDiff = (iWeeks + 1) * 5 - (iWeekday1 - iWeekday2);
            }

            iDateDiff -= iAdjust; // take into account both days on weekend

            return iDateDiff + 1; // add 1 because dates are inclusive
        },
        confirm() {
            this.$store
                .dispatch("employeeLeaves/edit", { id: this.itemId, payload: this.leave })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },
        back() {
            this.$emit("back");
        },
        download() {
            window.open(
                `/api/employeeLeaves/${this.leave.attachmentId}/attachment`,
                "_blank"
            );
        }
    },
};
</script>